import './App.css';
import MainPage from './app/modules/main/mainPage';
//update
function App() {
  return (
    <div className="App">
      <MainPage/>
    </div>
  );
}

export default App;
